import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { EventRegisterResponse } from '../types/api.types';

import { registerForEventService } from 'services/referral-event.service';

type UseEventRegistrationOptions = {
  eventId: string;
  onSuccess?: () => void;
  onError?: (message: string) => void;
};

export const useEventRegistration = ({ eventId, onSuccess, onError }: UseEventRegistrationOptions) => {
  return useMutation({
    mutationFn: () => registerForEventService(eventId),
    onSuccess,
    onError: (error: AxiosError<EventRegisterResponse>) => {
      const errorMessage = error.response?.data?.message || 'Registration failed. Please try again.';
      onError?.(errorMessage);
    },
  });
};
